var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.required)?_c('div',{staticClass:"error"},[_vm._v("Field is required. "+_vm._s(_vm.value))]):_c('div',{staticClass:"error"},[_vm._v(" "+_vm._s(_vm.value)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }